import { TriggerActionCategory } from "@octopusdeploy/octopus-server-client";
import { CreateOrEditScheduledTriggerPage } from "../../Triggers/Scheduled/CreateOrEditScheduledTriggerPage";
interface CreateRunbookScheduledTriggerPageProps {
    spaceId: string;
    projectSlug: string;
    runbookId?: string;
}
export function CreateRunbookScheduledTriggerPage({ spaceId, runbookId, projectSlug }: CreateRunbookScheduledTriggerPageProps) {
    return <CreateOrEditScheduledTriggerPage create={true} triggerActionCategory={TriggerActionCategory.Runbook} spaceId={spaceId} projectSlug={projectSlug} runbookId={runbookId}/>;
}
